const steps = {
  '1': 'This Black Friday we checked in to hear how you’re feeling',
  '2': 'These are the feelings people shared from behind their screens.',
  '3': 'words',
  '4': 'We found that more than 30% of people feel',
  '5': 'In a world that pushes us to rush, it’s up to us to slow down. Let’s pause for one moment',
  '6': 'video',
  '7': 'lamp',
  '8': 'blanket',
  '9': 'coupon',
  '10': 'Like all our products, the Black Velvet Napper is sustainably crafted.',
  '11': 'end',
};

class BlackVelvet extends HTMLElement {
  constructor() {
      super();
      this.active = this.querySelector('[data-steps][active]');
      this.wordBtn = this.querySelector('#add-word');
      this.wordsWrapper = this.querySelector('#words');
      this.wordInput = this.querySelector('[name="word"]');
      this.wordWrapper = this.querySelector('#word');
      this.caret = '<span class="caret"></span>';
      this.giantBtn = this.querySelector('#giant-button');
      this.blanketImg = this.querySelector('#napper-swoosh');
      this.stepVideos = this.querySelectorAll('.step-video');
      this.infoWrapper = this.querySelector('.info-wrapper');
      this.wordSpan = this.querySelector('#word-span');
      this.giantBtn.addEventListener('click', this.increaseBtn.bind(this));
  }
  noSpace(e) {
      if (e.which == 32) {
          e.preventDefault();
          return;
      }
  }
  handleWord() {
      this.wordWrapper.innerHTML = this.wordInput.value + this.caret;
      this.wordSpan.innerText = this.wordInput.value;
  }
  addWord() {
      const word = this.wordInput.value.toLowerCase();
      if (word.length === 0)
          return;
      this.wordBtn.setAttribute('disabled', true);
      this.querySelector('[data-step][active]').classList.add('show-cloud');
      this.activeStep = this.querySelector('[data-step][active]');
      window.scrollTo(0, 0);
      fetch('https://bearaby-words.herokuapp.com/add?word=' + word).catch(err => { console.log(err); });
      setTimeout(() => {
          this.wordsWrapper.querySelectorAll('span')[1].innerText = window.theme.words.join(' ');
          this.wordSpan.id = '';
          setTimeout(() => {
              this.activeStep.classList.add('show-cloud-text');
              setTimeout(nextStep, 4000);
          }, 2000);
      }, 1000);
  }
  testWords() {
      const word = this.wordInput.value.toLowerCase();
      if (word.length === 0)
          return;
      this.wordBtn.setAttribute('disabled', true);
      this.activeStep = this.querySelector('[data-step][active]');
      this.activeStep.classList.add('show-cloud');
      setTimeout(() => {
          this.wordsWrapper.querySelectorAll('span')[1].innerText = window.theme.words.join(' ');
          this.wordSpan.id = '';
          setTimeout(() => {
              this.activeStep.classList.add('show-cloud-text');
              setTimeout(nextStep, 7000);
          }, 2000);
      }, 1000);
  }
  increaseBtn() {
      var active = document.querySelector('[data-step][active]');
      active.removeAttribute('active');
      active.nextElementSibling.setAttribute('active', '');
      this.giantBtn.setAttribute('disabled', true);
      nextStep();
  }
  moveBlanket() {
      this.classList.remove('on-transition');
      this.blanketImg.style.bottom = '100%';
      setTimeout(nextStep, 1000);
  }
  showBlanket() {
      this.classList.add('on-transition');
      const bottom = Math.ceil(this.blanketImg.getBoundingClientRect().height);
      this.blanketImg.style.bottom = '-' + bottom + 'px';
      setTimeout(() => {
          this.activeStep = this.querySelector('[data-step][active]');
          this.activeStep.classList.add('bg-white');
          const title = this.activeStep.querySelector('.title');
          const text = steps[this.activeStep.getAttribute('data-step')];
          title.innerHTML = 'It’s not.';
      }, 1500);
  }
  discount() {
      document.querySelector('.coupon-code-wrapper').classList.add('active');
      setTimeout(nextStep, 6000);
  }
}

customElements.define('black-velvet', BlackVelvet);

function goBottom() {
  const windowHeight = window.innerHeight;
  const scrollHeight = document.body.scrollHeight;
  window.scrollTo(0, scrollHeight - windowHeight)
}

function typeWriter(el, text, i, fnCallback, nT) {
  const condition = (i < text.length);
  if (condition) {
      const num = i + 1;
      const diff = nT || 50;
      const t = diff > 10 ? diff : 10;
      const substring = text.substring(0, i + 1);
      el.innerHTML = num === text.length ? substring : substring + '<span class="caret"></span>';
      setTimeout(function () {
          typeWriter(el, text, num, fnCallback, nT);
      }, t);
  }
  else if (typeof fnCallback == 'function') {
      var tN = 2000;
      setTimeout(fnCallback, tN);
  }
}

function animationStart() {
  setTimeout(() => {
      const title = document.querySelector('[data-step="1"] .title');
      typeWriter(title, steps['1'], 0, nextStep);
  }, 2000);
}

function nextStep(t = 0) {
  const active = document.querySelector('[data-step][active]');
  const nextElement = active.nextElementSibling;
  if (!nextElement) {
      document.body.classList.add('on-transition');
      document.querySelector('.product-gallery').dataset.status = 'off';
      document.querySelector('.product-gallery').init();
      return;
  }
  active.setAttribute('block', '');
  active.removeAttribute('active');
  setTimeout(() => {
      nextElement.setAttribute('active', '');
      const title = nextElement.querySelector('.title');
      const text = steps[nextElement.getAttribute('data-step')];
      const info = nextElement.querySelector('.info');
      if (nextElement.classList.contains('block-step'))
          goBottom();
      if (nextElement.classList.contains('cloud-feelings'))
          setTimeout(() => {
              nextElement.nextElementSibling.setAttribute('block', '');
          }, 1000);
      if (text === 'end') {
          setTimeout(() => {
              document.querySelector('[data-step][active]').className = 'bg-white w-100 step-height';
              document.querySelectorAll('[data-step][block]').forEach(item => {item.parentNode.removeChild(item);})
          }, 2800);
          setTimeout(() => {
              document.body.classList.add('on-transition');
              document.querySelector('.product-gallery').dataset.status = 'off';
              document.querySelector('.product-gallery').init();
              window.scrollTo(0, 0);
          }, 7000);
          return;
      }
      else if (text === 'video') {
          return;
      }
      else if (text === 'words') {
          document.querySelector('#words span').innerHTML = window.theme.words.join(' ');
          document.querySelector('[data-step][active]').classList.add('show-cloud-text');
          setTimeout(nextStep, 4000);
          return;
      }
      else if (text === 'coupon') {
          setTimeout(() => {
              document.querySelector('.coupon-code-wrapper').classList.add('active');
              setTimeout(nextStep, 5000);
          }, 2500);
          return;
      }
      else if (text === 'blanket') {
          title.innerHTML = 'We’re not going to tell you our new Black Velvet Napper is only here for a limited time.';
          setTimeout(() => blackVelvet.showBlanket(), 3500);
          return;
      }
      else if (typeof text === 'object') {
          typeWriter(title, text[0], 0, () => blackVelvet.nextLine());
          return;
      }
      else if (text === 'discount') {
          typeWriter(title, 'Or entice you with a coupon code.', 0, () => blackVelvet.discount());
          return;
      }
      else if (nextElement.classList.contains('fade-effect')) {
          title.innerHTML = text;
          setTimeout(nextStep, 6000);
          return;
      }
      if (text && title) {
          const fn = info ? showInfo : nextElement.hasAttribute('auto') ? nextStep : false;
          const t = info ? 0 : 1000;
          typeWriter(title, text, 0, fn);
      }
  }, t);
}

document.querySelectorAll('.cloud-feelings button').forEach(function (button) {
  button.addEventListener('click', function () {
      if (document.querySelector('.cloud-feelings button.active'))
          document.querySelector('.cloud-feelings button.active').classList.remove('active');
      button.classList.add('active');
      document.querySelector('.cloud-feelings .title').innerHTML = `People shared<br class="large-up-hide"> ${button.dataset.feeling}<br> ${button.dataset.times} times`;
  });
});

function showInfo() {
  var active = document.querySelector('[data-step][active]');
  active.classList.add('show-info');
}
const blackVelvet = document.querySelector('black-velvet');
document.addEventListener('DOMContentLoaded', animationStart);

document.querySelector('#black-velvet-modal .icon-cross').addEventListener('click', () => {
    document.querySelector('#black-velvet-modal video').pause();
});
